import type {TitleWidgetPayload} from '../types';
import * as React from 'react';
import {TitleMedium, Icon} from '@spaced-out/ui-design-system';
import css from './title-widget.css';


export type TitleWidgetProps = TitleWidgetPayload;

export const TitleWidget = ({
  iconName = 'sparkles',
  children,
  highlightString,
}: TitleWidgetProps) => {
  return (
    <div className={css.container}>
      {iconName && (
        <Icon name={iconName} color="information" type="solid" size="large" />
      )}
      <TitleMedium highlightString={highlightString}>{children}</TitleMedium>
    </div>
  );
};
